import {retrieved} from "./get";
import {combineReducers} from "redux";

export default combineReducers({retrieved});
